<template>
  <div>
    <div class="member-login">
      <h3>Passwort zurücksetzen</h3>
      <p>Bitte geben Sie Ihre registrierte E-Mail Adresse und ein neues Passwort ein. Sie erhalten eine E-Mail mit einem Bestätigungslink.</p>
      <div class="member-input">
        <div class="input-wrap">
          <label>E-Mail Adresse
            <input type="email" v-model="memberData.Writable.Mitgliedemail">
          </label>
        </div>
      </div>
      <div class="input-wrap">
        <label>Passwort
          <input type="password" v-model="memberData.password">
        </label>
      </div>
      <button class="member-button" @click="login">Passwort zurücksetzen</button>

    </div>
    <div class="member-notice" v-if="errorMsg">
      <p>{{ errorMsg }}</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import get from "lodash.get"

export default {
  name: "ResetPassword",
  props:['error'],
  data() {
    return {
      errorMsg: this.error,
      memberData: {
        Writable: {
          Mitgliedemail: ''
        },
        password: ''
      },
    }
  },
  methods: {
    async login() {
      this.errorMsg = null;
      let url = window.appdata.reset;
      let data = this.memberData;
      let req = await axios.post(url, data);
      if (req.data.success) {
        this.$emit('reset-success');
      }
      if (!req.data.success) {
        this.handleError(req.data.data);
      }
    },
    handleError(data) {
      let msg = get(data, 'Errors.UserErrMsg', null);
      this.errorMsg = msg;
    }
  },
}
</script>

<style scoped>

</style>